import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { environment } from '../../../environments/environment';

/**
 * Prepends the configured `apiBaseUrl` to relative request URLs.
 *
 * Requests with absolute URLs (`http://`, `https://`, `//`) pass through
 * untouched. URLs that already begin with the configured base also pass
 * through — so callers that build `${environment.apiBaseUrl}/path` don't
 * get the base prepended a second time when the base is itself a relative
 * path (e.g. `/api/v1`).
 */
export const apiBaseInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  if (req.url.startsWith('http://') || req.url.startsWith('https://') || req.url.startsWith('//')) {
    return next(req);
  }
  const base = environment.apiBaseUrl.replace(/\/$/, '');
  if (base && (req.url === base || req.url.startsWith(`${base}/`))) {
    return next(req);
  }
  const path = req.url.startsWith('/') ? req.url : `/${req.url}`;
  return next(req.clone({ url: `${base}${path}` }));
};
